import { useQuery } from "convex/react";
import { api } from "../../api";
import { type GenericId as Id } from "convex/values";
import { useEffect } from "react";

export const useNetworkRuleDetail = (ruleId: string | null) => {
  const ruleDetail = useQuery(
    api.rules.get.rules,
    ruleId ? { rules: [ruleId as Id<"rules">] } : "skip"
  );

  // Log the raw response for debugging
  useEffect(() => {
    if (ruleId) {
      console.log('=== Network Rule Detail Debug ===');
      console.log('Rule ID requested:', ruleId);
      console.log('Raw API response (full array):', ruleDetail);
      console.log('Extracted rule data (first item):', ruleDetail?.[0]);
      console.log('================================');
    }
  }, [ruleId, ruleDetail]);

  return {
    data: ruleDetail?.[0],
    isLoading: ruleDetail === undefined,
  };
};
